import script from "./CatalogMenuName.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogMenuName.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogMenuName.vue?vue&type=style&index=0&id=4f747c43&lang=scss"

const __exports__ = script;

export default __exports__